<template>
  <div>
    <div class="projects-list">
      <div
        class="project-box project-hover"
        style="cursor: pointer"
        v-for="current in dataTabla.results"
        v-bind:key="current.id"
        @click="rowClick(current)"
      >
        <div class="project-head">
          <div class="project-title">
            <h6>
              #{{ current.numero }}
              <div v-if="!current.fecha_finalizacion" class="badge badge-success">
                Abierto
              </div>
              <div v-if="current.fecha_finalizacion" class="badge badge-dark">
                Finalizado
              </div>
            </h6>
            <span class="font-weight-bold">{{ current.tienda_obj.nombre }}</span>
          </div>
        </div>
        <div class="project-info">
          <div class="row align-items-center">
            <div class="col-12">
              <div class="row">
                <div class="col-6 col-md-3">
                  <div class="el-tablo highlight text-center">
                    <div class="label">Fecha de Creación</div>
                    <div>
                      <strong>
                        <p class="text-center" style="color: #3ab41d">
                          {{ current.fecha_creacion | moment("DD/MM/YYYY HH:mm:ss") }}
                        </p>
                      </strong>
                    </div>
                  </div>
                </div>
                <div class="col-6 col-md-3">
                  <div class="el-tablo highlight text-center">
                    <div class="label">Fecha de Finalización</div>
                    <div>
                      <strong>
                        <p class="text-center" style="color: #3ab41d">
                          {{ current.fecha_finalizacion | moment("DD/MM/YYYY HH:mm:ss") }}
                        </p>
                      </strong>
                    </div>
                  </div>
                </div>
                <div class="col-6 col-md-3">
                  <div class="el-tablo highlight text-center">
                    <div class="label">Usuario</div>
                    <div>
                      <strong>
                        <p class="text-center" style="color: #3ab41d">
                          {{ current.usuario.username }}
                        </p>
                      </strong>
                    </div>
                  </div>
                </div>
                <div class="col-6 col-md-3">
                  <div class="el-tablo highlight text-center">
                    <div class="label">Conteos que agrupa</div>
                    <div>
                      <strong>
                        <p class="text-center" style="color: #3ab41d">
                          {{ current.total_conteos }}
                        </p>
                      </strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import DynamicService from "@/services/commons/DynamicService";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";
import Vue from "vue";
Vue.use(require("vue-moment"));

export default {
  components: {
    PaginationComponent,
    UsuarioEnTablaComponent,
    ProductoSelectComponentV2,
  },
  props: ["dataTabla"],
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      posiciones: [],
      searchtext: "",
      filtro_estado: "",
      currentDet: "",
      current: {
        producto: "",
        cantidad: 0,
        posicion: "",
      },
    };
  },
  computed: {},
  mounted() {},
  methods: {
    rowClick(detalle) {
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "inventario-conteo-agrupado-editar",
          params: { id: detalle.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        this.$router.push({
          name: "inventario-conteo-agrupado-editar",
          params: { id: detalle.id },
        });
      }
    },
  },
};
</script>
